import React from "react";
import Link, { withPrefix, withAssetPrefix, navigate, push, replace, navigateTo, parsePath } from "gatsby-link";
import { useScrollRestoration } from "gatsby-react-router-scroll";
import PageRenderer from "./public-page-renderer";
import loader from "./loader";
const prefetchPathname = loader.enqueue;
const StaticQueryContext = /*#__PURE__*/React.createContext({});
function StaticQueryDataRenderer(_ref) {
  let {
    staticQueryData,
    data,
    query,
    render
  } = _ref;
  const finalData = data ? data.data : staticQueryData[query] && staticQueryData[query].data;
  return /*#__PURE__*/React.createElement(React.Fragment, null, finalData && render(finalData), !finalData && /*#__PURE__*/React.createElement("div", null, "Loading (StaticQuery)"));
}
const StaticQuery = props => {
  const {
    data,
    query,
    render,
    children
  } = props;
  return /*#__PURE__*/React.createElement(StaticQueryContext.Consumer, null, staticQueryData => /*#__PURE__*/React.createElement(StaticQueryDataRenderer, {
    data: data,
    query: query,
    render: render || children,
    staticQueryData: staticQueryData
  }));
};
const useStaticQuery = query => {
  var _context$query;
  if (typeof React.useContext !== `function` && process.env.NODE_ENV === `development`) {
    throw new Error(`You're likely using a version of React that doesn't support Hooks\n` + `Please update React and ReactDOM to 16.8.0 or later to use the useStaticQuery hook.`);
  }
  const context = React.useContext(StaticQueryContext);

  // query is a stringified number like `3303882` when wrapped with graphql, If a user forgets
  // to wrap the query in a grqphql, then casting it to a Number results in `NaN` allowing us to
  // catch the misuse of the API and give proper direction
  if (isNaN(Number(query))) {
    throw new Error(`useStaticQuery was called with a string but expects to be called using \`graphql\`. Try this:

import { useStaticQuery, graphql } from 'gatsby';

useStaticQuery(graphql\`${query}\`);
`);
  }
  if ((_context$query = context[query]) !== null && _context$query !== void 0 && _context$query.data) {
    return context[query].data;
  } else {
    throw new Error(`The result of this StaticQuery could not be fetched.\n\n` + `This is likely a bug in Gatsby and if refreshing the page does not fix it, ` + `please open an issue in https://github.com/gatsbyjs/gatsby/issues`);
  }
};
function graphql() {
  throw new Error(`It appears like Gatsby is misconfigured. Gatsby related \`graphql\` calls ` + `are supposed to only be evaluated at compile time, and then compiled away. ` + `Unfortunately, something went wrong and the query was left in the compiled code.\n\n` + `Unless your site has a complex or custom babel/Gatsby configuration this is likely a bug in Gatsby.`);
}
export { Link, withAssetPrefix, withPrefix, graphql, parsePath, navigate, push,
// TODO replace for v3
replace,
// TODO remove replace for v3
navigateTo,
// TODO: remove navigateTo for v3
useScrollRestoration, StaticQueryContext, StaticQuery, PageRenderer, useStaticQuery, prefetchPathname };